import React from 'react';
import { Button, Icon, Segment } from 'semantic-ui-react';

function ActiveTicket(props) {
  const { selectedTicket, setFullscreen } = props;

  const downloadImage = () => {
    if (!selectedTicket?.image) return;
    const link = document.createElement('a');
    link.href = selectedTicket.image;
    link.download = 'ticket.png';
    link.click();
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'auto',
      }}
    >
      {/* Close / Download bar */}
      <div
        style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          display: 'flex',
          gap: '10px',
          zIndex: 10000,
        }}
      >
        <Button color="green" onClick={downloadImage}>
          <Icon name="download" /> Download
        </Button>
        <Button color="grey" onClick={() => setFullscreen('')}>
          <Icon name="close" /> Close
        </Button>
      </div>

      {/* Game info */}
      {selectedTicket?.gameInfo && (
        <div
          style={{
            color: '#d8ac49',
            textAlign: 'center',
            marginBottom: '20px',
            fontFamily: "'Bungee', cursive",
          }}
        >
          <h2 style={{ margin: 0 }}>{selectedTicket.gameInfo.event_name}</h2>
          <p style={{ color: '#aaa', margin: '5px 0' }}>
            {selectedTicket.gameInfo.date} - {selectedTicket.gameInfo.time} | {selectedTicket.gameInfo.venue}
          </p>
        </div>
      )}

      {/* Ticket image */}
      {selectedTicket?.image ? (
        <img
          src={selectedTicket.image}
          alt="Generated ticket"
          style={{
            maxWidth: '90vw',
            maxHeight: '70vh',
            borderRadius: '8px',
            boxShadow: '0 4px 30px rgba(216, 172, 73, 0.3)',
          }}
        />
      ) : (
        <Segment inverted placeholder>
          <p>No ticket selected</p>
        </Segment>
      )}
    </div>
  );
}

export default ActiveTicket;
